import React, { useRef } from 'react'
import OriginalModal from 'react-modal'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

export const CloseButton = styled.button`
  position: absolute;
  display: block;
  top: 6px;
  right: 8px;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 8px;
  z-index: 20;
  color: white;
  font-size: 2rem;
`

OriginalModal.setAppElement('#app')

type ModalComponentProps = {
  isOpen: boolean
  onRequestClose: () => void
  className: string
  overlayClassName: string
  style?: OriginalModal.Styles
  children: React.ReactNode
}

const ReactModal = OriginalModal as unknown as React.ComponentType<ModalComponentProps>

export default function Modal({
  isOpen,
  onClose,
  scrollY = false,
  children,
  baseWidth,
  baseHeight,
  styles,
  className,
}: {
  isOpen: boolean
  onClose: () => void
  scrollY?: boolean
  children: React.ReactNode
  baseWidth?: string
  baseHeight?: string
  styles?: OriginalModal.Styles
  className?: string
}) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={`prix-modal ${className ? className : ''}`}
      style={{
        content: {
          ...(styles?.content || {}),
          flex: `0 1 ${baseWidth}`,
          height: `${baseHeight}`,
        },
        overlay: styles?.overlay,
      }}
      overlayClassName='prix-modal-overlay'
    >
      {children}
      <CloseButton
        onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          event.preventDefault()
          onClose()
        }}
      >
        <FontAwesomeIcon icon={faTimes} />
      </CloseButton>
    </ReactModal>
  )
}
